module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_data_lake-small-7ee945dd3dbc83064373a3348c03fb49.png";